import {
  CRolesCode,
  TRolesCode
} from "@shared/models/enums/roles/roles-code.enum";
import {
  CRolesId,
  TRolesId
} from "@shared/models/enums/roles/roles-id.enum";
import {
  CRolesName,
  TRolesName
} from "@shared/models/enums/roles/roles-name.enum";

type roleCode = keyof TRolesCode;
export type IRoles = {
  [r in roleCode]: {
    name: TRolesName[r];
    id: TRolesId[r];
    code: TRolesCode[r];
  };
};

const CRoles: IRoles = {
  BROKER: {
    code: CRolesCode.BROKER,
    id: CRolesId.BROKER,
    name: CRolesName.BROKER
  },
  BROKER_MANAGER: {
    code: CRolesCode.BROKER_MANAGER,
    id: CRolesId.BROKER_MANAGER,
    name: CRolesName.BROKER_MANAGER
  },
  ADMIN: {
    code: CRolesCode.ADMIN,
    id: CRolesId.ADMIN,
    name: CRolesName.ADMIN
  },
  SUPER_ADMIN: {
    code: CRolesCode.SUPER_ADMIN,
    id: CRolesId.SUPER_ADMIN,
    name: CRolesName.SUPER_ADMIN
  },
  SENIOR: {
    code: CRolesCode.SENIOR,
    id: CRolesId.SENIOR,
    name: CRolesName.SENIOR
  },
  JUNIOR: {
    code: CRolesCode.JUNIOR,
    id: CRolesId.JUNIOR,
    name: CRolesName.JUNIOR
  },
  CLIENT: {
    code: CRolesCode.CLIENT,
    id: CRolesId.CLIENT,
    name: CRolesName.CLIENT
  }
};

export const CROLES_ARRAY = [
  CRoles.ADMIN,
  CRoles.BROKER,
  CRoles.BROKER_MANAGER,
  CRoles.JUNIOR,
  CRoles.SENIOR,
  CRoles.SUPER_ADMIN,
  CRoles.CLIENT
];

type roleId = keyof TRolesId;
export type IRolesObject = {
  [r in roleId as number]: {
    name: TRolesName[r];
    id: TRolesId[r];
    code: TRolesCode[r];
  };
};
const CRolesID: IRolesObject = {
  [CRolesId.ADMIN]: {
    code: CRolesCode.ADMIN,
    id: CRolesId.ADMIN,
    name: CRolesName.ADMIN
  },
  [CRolesId.BROKER]: {
    code: CRolesCode.BROKER,
    id: CRolesId.BROKER,
    name: CRolesName.BROKER
  },
  [CRolesId.BROKER_MANAGER]: {
    code: CRolesCode.BROKER_MANAGER,
    id: CRolesId.BROKER_MANAGER,
    name: CRolesName.BROKER_MANAGER
  },
  [CRolesId.SUPER_ADMIN]: {
    code: CRolesCode.SUPER_ADMIN,
    id: CRolesId.SUPER_ADMIN,
    name: CRolesName.SUPER_ADMIN
  },
  [CRolesId.SENIOR]: {
    code: CRolesCode.SENIOR,
    id: CRolesId.SENIOR,
    name: CRolesName.SENIOR
  },
  [CRolesId.JUNIOR]: {
    code: CRolesCode.JUNIOR,
    id: CRolesId.JUNIOR,
    name: CRolesName.JUNIOR
  },
  [CRolesId.CLIENT]: {
    code: CRolesCode.CLIENT,
    id: CRolesId.CLIENT,
    name: CRolesName.CLIENT
  }
};

export { CRoles, CRolesID };

export const CROLES_ARRAY_FOR_LABEL = CROLES_ARRAY.map(x => ({
  label: x.name,
  value: x.id.toLocaleString()
}));
